import { c as _c } from "react/compiler-runtime";
import { DonationIntervals } from 'api-graphql-types/enums';
import { toLowerCase } from 'betterplace-utils';
import { Fieldset, Heading, ToggleButton, Tooltip } from 'design-system/client';
import { useTranslations } from 'next-intl';
import { memo } from 'react';
import styles from './IntervalSelection.module.css';
import MonthlyMatchingBanner from './MonthlyMatchingBanner';
import DonationFormField from '@/donationPages/_dependencies/components/DonationFormField';
import { useDonationFormContext, useDonationFormValues } from '@/donationPages/_dependencies/helpers';
import { usePaymentMethodsToRender } from '@/donationPages/_dependencies/NativePaymentMethods';
const intervals = [DonationIntervals.Single, DonationIntervals.Monthly, DonationIntervals.Yearly];
function IntervalInput_(t0) {
  const $ = _c(15);
  const {
    interval,
    disabled
  } = t0;
  const t = useTranslations("nextjs");
  let t1;
  if ($[0] !== t) {
    t1 = t("donate.recurring_disabled_tooltip");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !disabled;
  let t3;
  if ($[2] !== interval) {
    t3 = toLowerCase(interval);
    $[2] = interval;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `donate.recurring_interval.${t3}`;
  let t5;
  if ($[4] !== t || $[5] !== t4) {
    t5 = t(t4);
    $[4] = t;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== disabled || $[8] !== interval || $[9] !== t5) {
    t6 = <DonationFormField name="interval" type="radio" as={ToggleButton} value={interval} size="small" disabled={disabled} className={styles.radioButton}>{t5}</DonationFormField>;
    $[7] = disabled;
    $[8] = interval;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t6) {
    t7 = <div><Tooltip content={t1} inactive={t2}>{t6}</Tooltip></div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
const IntervalInput = memo(IntervalInput_);
function IntervalItems_({
  isRecurringPaymentMethod
}: {
  isRecurringPaymentMethod: boolean;
}) {
  return intervals.map(interval => {
    const disabled = !isRecurringPaymentMethod && interval !== DonationIntervals.Single;
    return <IntervalInput key={interval} interval={interval} disabled={disabled} />;
  });
}
const IntervalItems = memo(IntervalItems_);
function IntervalSelection() {
  const $ = _c(18);
  const t = useTranslations("nextjs");
  const {
    formState: t0
  } = useDonationFormContext();
  const {
    errors
  } = t0;
  const {
    recurringPaymentMethodsToRender
  } = usePaymentMethodsToRender();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["payment_method"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [paymentMethod] = useDonationFormValues(t1);
  let t2;
  if ($[1] !== paymentMethod || $[2] !== recurringPaymentMethodsToRender) {
    t2 = recurringPaymentMethodsToRender.includes(paymentMethod);
    $[1] = paymentMethod;
    $[2] = recurringPaymentMethodsToRender;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isRecurringPaymentMethod = t2;
  let t3;
  if ($[4] !== t) {
    t3 = t("donate.attributes.interval");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <Heading level="heading-xs" className={styles.heading}>{t3}</Heading>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = errors.interval?.message;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      alignment: "justified",
      space: "100"
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isRecurringPaymentMethod) {
    t7 = <IntervalItems isRecurringPaymentMethod={isRecurringPaymentMethod} />;
    $[9] = isRecurringPaymentMethod;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t7) {
    t8 = <Fieldset legend={t4} error={t5} layoutProps={t6}>{t7}</Fieldset>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <MonthlyMatchingBanner className={styles.matchingBanner} />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8) {
    t10 = <div>{t8}{t9}</div>;
    $[16] = t8;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}
export default memo(IntervalSelection);